import React, { Component } from 'react';
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Checkbox, Form, Icon, List } from "semantic-ui-react";
import { SettingsContext } from "../context";
import api from "../context/api";
import AccordionItem from "./AccordionItem";
import MaterialAccordionItem from "./MaterialAccordionItem";
import MaterialAdd from "./MaterialAdd";
import MaterialRule from "./MaterialRule";

const initialRules = [
  { label: "Triplanar", value: "0" },
  { label: "UV", value: "1" },
];
function MaterialInfo() {
 const { editorProductInfo, authenticationToken, authorizationHeader,gltfMaterials,updateSceneMaterials,refreshMaterial } =
    useContext(SettingsContext);

  const modelViewer = document.getElementById("modelViewer");
  const [materialsPart, setMaterialsPart] = useState([]);
  const [mappingTypes] = useState(initialRules);
  const [baseNormalFileName, setBaseNormalFileName] = useState();
  const [baseAoFileName, setBaseAoFileName] = useState();
  const [baseAoMap, setBaseAoMap] = useState();
  const [baseNormalMap, setBaseNormalMap] = useState();
  const options = [0.125, 0.25, 0.5, 1.0];

  const handleChangeAoMap = (value) => {
    setBaseAoMap(value);
  };

  const handleChangeNormalMap = (value) => {
    setBaseNormalMap(value);
  };
 //buraya bak kesinlikle kesinlikle kesinlikle bak bak bak
  useEffect(() => {
    const modelViewer = document.getElementById("modelViewer");
    modelViewer.addEventListener(
      "init-model-load",
      updateSceneMaterials.bind(this)
    );
    getMaterialPartByProduct();
    updateSceneMaterials();
  }, [modelViewer]);
  useEffect(()=>{
        updateSceneMaterials();

  },[refreshMaterial]);
  const getMaterialPartByProduct = async () => {
    if (!editorProductInfo.id) return;

    let url =
      process.env.REACT_APP_BACKEND_API +
      "material/list/partAndRules/" +
      editorProductInfo.id;
    axios.get(url, authorizationHeader).then((res) => {
      const d = res.data;
      setMaterialsPart(d);
    });
  };

  const updateMaterialPart = (index) => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Material Part Güncelleniyor..",
      })
    );

    let productPart = materialsPart[index];
    let file = productPart.baseNormalMapFile;

    var formData = new FormData();

    var json = JSON.stringify(productPart);

    const blob = new Blob([json], {
      type: "application/json",
    });

    formData.append("productPart", blob);
    formData.append("baseNormalMap", file);
    formData.append("productId", editorProductInfo.id);

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + `material/update/part`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    }).then(
      (res) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Material Part Güncellendi.",
          })
        );
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      },
      (rej) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Material Part Güncellenemedi",
          })
        );
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      }
    );
  };

  const updateMaterial = (materialPart, index) => {
    const newMaterialsParts = [...materialsPart];
    newMaterialsParts[index] = materialPart;

    gltfMaterials.forEach((e) => {
      if (e.name == materialPart.name && e.map) {
        const s = (e.map.repeat.x / materialPart.oldSize) * materialPart.size;
        e.map.repeat.set(s, s);
      }
    });

    setMaterialsPart(newMaterialsParts);
  };

  const handleBaseNormal = (e, materialPart, index) => {
    setBaseNormalFileName(
      materialPart.name + " file: " + e.target.files[0].name
    );
    materialPart.baseNormalMapFile = e.target.files[0];
    materialPart.baseNormalMapFileName = e.target.files[0].name;
    const newMaterialsParts = [...materialsPart];
    newMaterialsParts[index] = materialPart;

    setMaterialsPart(newMaterialsParts);
  };

  const handleBaseAo = (e, materialPart, index) => {
    setBaseAoFileName(materialPart.name + " file: " + e.target.files[0].name);
    materialPart.baseAoMapFile = e.target.files[0];
    materialPart.baseAoMapFileName = e.target.files[0].name;
    const newMaterialsParts = [...materialsPart];
    newMaterialsParts[index] = materialPart;

    setMaterialsPart(newMaterialsParts);
  };

    return ( 
<div>
  <AccordionItem header="Materials">
        <div className="accordion">
          <div style={{ width: "100%" }} className="materialsList">
            <AccordionItem header="Material Parts">
              <List>
                {materialsPart?.map((materialPart, partIndex) => {
                  const filteredOptionsBaseAoMap = options.filter(
                    (option) => option > materialPart.baseAoMapResolution
                  );
                  const filteredOptionsNormalMap = options.filter(
                    (option) => option > materialPart.baseNormalMapResolution
                  );
                  return (
                    <div key={partIndex}>
                      <AccordionItem header={materialPart?.name}>
                        <Form>
                          <Form.Group widths="equal">
                            <Form.Input
                              label="Name"
                              onChange={(e) => {
                                materialPart.name = e.target.value;
                                updateMaterial(materialPart, partIndex);
                              }}
                              defaultValue={materialPart?.name}
                            />
                          </Form.Group>

                          <Form.Group widths="equal">
                            <Form.Input
                              label="Code"
                              onChange={(e) => {
                                let code = e.target.value;
                                if (code == "") code = null;
                                materialPart.code = code;
                                updateMaterial(materialPart, partIndex);
                              }}
                              error={
                                materialPart?.error ? materialPart.error : false
                              }
                              defaultValue={
                                materialPart?.code ? materialPart.code : null
                              }
                            />

                            <Form.Input
                              label="Ordering"
                              onChange={(e) => {
                                materialPart.orderIndex = e.target.value;
                                updateMaterial(materialPart, partIndex);
                              }}
                              defaultValue={materialPart?.orderIndex}
                            />
                          </Form.Group>

                          <Form.Group widths="equal">
                            <Form.Input
                              label="Ao Strength"
                              onChange={(e) => {
                                materialPart.aoStrength = e.target.value;
                                updateMaterial(materialPart, partIndex);
                              }}
                              error={
                                materialPart?.error ? materialPart.error : false
                              }
                              defaultValue={
                                materialPart?.aoStrength
                                  ? materialPart.aoStrength
                                  : "0"
                              }
                            />

                            <Form.Input
                              label="Product Size"
                              onChange={(e) => {
                                if (e.target.value > 0) {
                                  materialPart.oldSize = materialPart.size;
                                  materialPart.size = e.target.value;
                                  updateMaterial(materialPart, partIndex);
                                }
                              }}
                              type="number"
                              error={
                                materialPart?.error ? materialPart.error : false
                              }
                              defaultValue={
                                materialPart?.size ? materialPart.size : "0"
                              }
                            />
                          </Form.Group>
                          <Form.Group widths="equal">
                            <Form.Input
                              label="Quality Size"
                              onChange={(e) => {
                                materialPart.textureSize = e.target.value;
                                updateMaterial(materialPart, partIndex);
                              }}
                              error={
                                materialPart?.error ? materialPart.error : false
                              }
                              defaultValue={
                                materialPart?.textureSize
                                  ? materialPart.textureSize
                                  : "0"
                              }
                            />
                            <div
                              style={{
                                width: "100%",
                                margin: "5px",
                                color: "black",
                              }}
                            >
                              <Select
                                menuPosition="fixed"
                                isSearchable
                                selection
                                defaultValue={
                                  mappingTypes.filter(
                                    (b) => b.value == materialPart.mappingType
                                  )[0]
                                }
                                onChange={(e) => {
                                  materialPart.mappingType = e?.value;
                                  updateMaterial(materialPart, partIndex);
                                }}
                                options={mappingTypes}
                                placeholder="Select Mapping Type"
                              />
                            </div>
                          </Form.Group>
                          <Form.Group
                            widths="equal"
                          >
                            <div
                              style={{
                                width: "80%",
                                margin: "5px",
                                color: "black",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {materialPart.baseNormalMapResolution && (
                                  <>
                                    {" "}
                                    <label style={{ color: "white" }}>
                                      Base Normal:{" "}
                                      {materialPart.baseNormalMapResolution}
                                    </label>
                                    <br />
                                    {filteredOptionsNormalMap.map(
                                      (option, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            width: "45%",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            id={`materialNormalMap-${partIndex}-option-${option}`}
                                            name={`materialNormalMap-${partIndex}`}
                                            value={option}
                                            checked={baseNormalMap === option}
                                            onChange={() => {
                                              handleChangeNormalMap(option);
                                            }}
                                          />
                                          <label
                                            style={{
                                              color: "white",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {option}
                                          </label>
                                        </div>
                                      )
                                    )}
                                  </>
                                )}

                              </div>
                              {(materialPart.baseNormalMapResolution && materialPart.baseNormalMapResolution !== 1.0) && (
                                <>
                                  <button
                                    style={{ margin: 5 }}
                                    className="saveButton"
                                    onClick={() => {
                                      if (baseNormalMap) {
                                        api.updateBaseNormalMapResolution(
                                          baseNormalMap,
                                          materialPart.id
                                        );
                                        console.log("button çalışmakta");
                                        window.location.reload();
                                      }
                                    }}
                                  >
                                    {" "}
                                    <Icon name="lab" /> update
                                  </button>
                                </>
                              )}

                            </div>
                            <div
                              style={{
                                width: "80%",
                                margin: "5px",
                                color: "black",
                                float: "right",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {materialPart.baseAoMapResolution && (
                                  <>
                                    <label style={{ color: "white" }}>
                                      BaseAoMap: {materialPart.baseAoMapResolution}
                                    </label>
                                    <br />

                                    {filteredOptionsBaseAoMap.map((option, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          width: "45%",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          id={`materialAoMap-${partIndex}-option-${option}`}
                                          name={`materialAoMap-${partIndex}`}
                                          value={option}
                                          checked={baseAoMap === option}
                                          onChange={() => {
                                            handleChangeAoMap(option);
                                          }}
                                        />
                                        <label
                                          style={{
                                            color: "white",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    ))}
                                  </>
                                )}
                              </div>
                              {(materialPart.baseAoMapResolution && materialPart.baseAoMapResolution !== 1.0) && (
                                <>

                                  <button
                                    style={{ margin: 5 }}
                                    className="saveButton"
                                    onClick={() => {
                                      if (baseAoMap) {
                                        api.updateBaseAoMapResolution(
                                          baseAoMap,
                                          materialPart.id
                                        );
                                        window.location.reload();
                                      }
                                    }}
                                  >
                                    {" "}
                                    <Icon name="lab" /> update
                                  </button>
                                </>
                              )}
                            </div>
                          </Form.Group>

                          <div className="row">
                            <div className="column">
                              {materialPart.baseNormalMap ? (
                                <img
                                  src={materialPart.baseNormalMap}
                                  style={{ margin: "1em" }}
                                  width={100}
                                  height={100}
                                />
                              ) : (
                                ""
                              )}
                              <Form.Field widths="equal">
                                <label
                                  htmlFor={
                                    "uploadBaseNormal-" + materialPart.id
                                  }
                                >
                                  <Icon name="upload" size="big" />
                                  Base Normal{" "}
                                </label>
                                <input
                                  type="file"
                                  onChange={(e) => {
                                    handleBaseNormal(
                                      e,
                                      materialPart,
                                      partIndex
                                    );
                                  }}
                                  hidden
                                  id={"uploadBaseNormal-" + materialPart.id}
                                />
                                <label
                                  value={materialPart.baseNormalMap}
                                  style={{ color: "white" }}
                                >
                                  {baseNormalFileName}
                                </label>
                              </Form.Field>
                              <Form.Field>
                                <label>Enable Basemap :</label>
                                <Checkbox
                                  onClick={() => {
                                    // eslint-disable-next-line no-unused-expressions
                                    (materialPart.baseNormalMapEnable =
                                      !materialPart.baseNormalMapEnable),
                                      updateMaterial(materialPart, partIndex);
                                  }}
                                  toggle
                                  checked={materialPart.baseNormalMapEnable}
                                />
                              </Form.Field>
                            </div>
                            <div className="column">
                              {materialPart.baseAoMap ? (
                                <img
                                  src={materialPart.baseAoMap}
                                  style={{ margin: "1em" }}
                                  width={100}
                                  height={100}
                                />
                              ) : (
                                ""
                              )}

                              <Form.Field widths="equal">
                                <label
                                  htmlFor={"uploadBaseAo-" + materialPart.id}
                                >
                                  <Icon name="upload" size="big" />
                                  Base Ao{" "}
                                </label>
                                <input
                                  type="file"
                                  onChange={(e) => {
                                    handleBaseAo(e, materialPart, partIndex);
                                  }}
                                  hidden
                                  id={"uploadBaseAo-" + materialPart.id}
                                />
                                <label
                                  value={materialPart.baseAoMap}
                                  style={{ color: "white" }}
                                >
                                  {baseAoFileName}
                                </label>
                              </Form.Field>

                              <Form.Field>
                                <label>Enable Aomap :</label>
                                <Checkbox
                                  onClick={() => {
                                    // eslint-disable-next-line no-unused-expressions
                                    (materialPart.baseAoMapEnable =
                                      !materialPart.baseAoMapEnable),
                                      updateMaterial(materialPart, partIndex);
                                  }}
                                  toggle
                                  checked={materialPart.baseAoMapEnable}
                                />
                              </Form.Field>
                            </div>
                          </div>
                          <Form.Group>
                            <button
                              className="saveButton"
                              onClick={() => updateMaterialPart(partIndex)}
                            >
                              Update
                            </button>
                          </Form.Group>

                          <br />
                          <Form.Group>
                            <MaterialRule
                              materialPart={materialPart}
                              materialsPart={materialsPart}
                              partIndex={partIndex}
                            />
                          </Form.Group>
                        </Form>
                      </AccordionItem>
                    </div>
                  );
                })}
              </List>
            </AccordionItem>
            <AccordionItem header="Scene Materials">
              <List>
                {gltfMaterials.map((material, index) => {
                  return (
                    <div key={index} className="row">
                      <MaterialAccordionItem
                        material={material}
                        index={index}
                      />
                    </div>
                  );
                })}
              </List>
            </AccordionItem>
          </div>
        </div>
        <br />
      </AccordionItem>

</div>
     );
}

export default MaterialInfo;